import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-0" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "ms-auto d-flex gap-1 align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-sign-out mr-1" }, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-times mr-1" }, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "text-secondary" }
const _hoisted_7 = { class: "text-dark" }
const _hoisted_8 = {
  class: "alert alert-info mt-3",
  style: {"padding":"5px 10px"}
}
const _hoisted_9 = { class: "mb-0 font-s-13 text-dark" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-warning mt-3",
  style: {"padding":"5px 10px"}
}
const _hoisted_11 = { class: "mb-0 font-s-13 text-danger" }
const _hoisted_12 = {
  key: 1,
  class: "alert alert-warning mt-3",
  style: {"padding":"5px 10px"}
}
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = {
  key: 2,
  class: "alert alert-info mt-3",
  style: {"padding":"5px 10px"}
}
const _hoisted_15 = { class: "mb-0 font-s-13 text-dark" }
const _hoisted_16 = {
  key: 0,
  class: "text-center mt-3"
}
const _hoisted_17 = { class: "mt-3" }
const _hoisted_18 = { class: "text-secondary" }
const _hoisted_19 = {
  key: 0,
  class: "text-success"
}
const _hoisted_20 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_21 = { class: "text-dark" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "question-content" }
const _hoisted_25 = { class: "list-group" }
const _hoisted_26 = ["data-uid"]
const _hoisted_27 = ["onUpdate:modelValue", "id", "value"]
const _hoisted_28 = ["onUpdate:modelValue", "id", "value"]
const _hoisted_29 = ["for"]
const _hoisted_30 = {
  key: 0,
  class: "badge text-bg-secondary mr-1"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-minus-circle" }, null, -1 /* HOISTED */)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "badge text-bg-success mr-1"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check" }, null, -1 /* HOISTED */)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 2,
  class: "badge text-bg-danger mr-1"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-times" }, null, -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "form-check-label stretched-link" }
const _hoisted_40 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */)
const _hoisted_42 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = {
  key: 0,
  class: "valid-feedback d-block"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle mr-1" }, null, -1 /* HOISTED */)
const _hoisted_46 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-times-circle mr-1" }, null, -1 /* HOISTED */)
const _hoisted_48 = {
  key: 2,
  class: "invalid-feedback d-block"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */)
const _hoisted_50 = { class: "d-flex align-items-center mt-4" }
const _hoisted_51 = { class: "text-secondary" }
const _hoisted_52 = { class: "ms-auto" }
const _hoisted_53 = ["onClick", "disabled"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle" }, null, -1 /* HOISTED */)
const _hoisted_55 = ["onClick", "disabled"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */)
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */)
const _hoisted_59 = ["onClick", "disabled"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */)
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */)
const _hoisted_63 = {
  key: 1,
  class: "alert alert-warning mt-3",
  style: {"padding":"5px 10px"}
}
const _hoisted_64 = { class: "mb-0 font-s-13 text-dark" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckMark = _resolveComponent("CheckMark")
  const _component_FailMark = _resolveComponent("FailMark")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["course-quiz-content mt-0", {'form-loading':($data.quiz.loading || $data.quiz.submit_loading)}])
  }, [
    _createElementVNode("h5", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString($data.quiz.data?.title) + " ", 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          (!$data.quiz.is_submitted && $options.checkQuizEndTime($props.quizData.end_time) && $options.checkQuizMaxAttempts)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[0] || (_cache[0] = $event => ($options.exitQuiz())),
                class: "btn btn-sm btn-danger rounded-pill"
              }, [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Exit')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          ($data.quiz.is_submitted || !$options.checkQuizEndTime($props.quizData.end_time) || !$options.checkQuizMaxAttempts)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[1] || (_cache[1] = $event => ($options.closeQuiz())),
                class: "btn btn-sm btn-warning rounded-pill",
                tooltip: "Close Quiz"
              }, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Close')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("b", _hoisted_6, _toDisplayString($setup.lms_website.__('End At')) + " : ", 1 /* TEXT */),
      _createTextVNode(),
      _createElementVNode("b", _hoisted_7, _toDisplayString($setup.moment(`${$props.quizData.end_date} ${$props.quizData.end_time}`).format('DD, MMM ( hh:mm a )')), 1 /* TEXT */)
    ]),
    ($options.checkQuizMaxAttempts)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($options.checkQuizStartTime($props.quizData?.start_time))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString($setup.lms_website.__('You will have to get {0}% correct answers in order to pass the quiz.', [$data.quiz.data?.passing_percentage])), 1 /* TEXT */)
                ]),
                ($data.endCountdown && (!$data.quiz.submit_loading || !$data.quiz.is_submitted))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, [
                        _createTextVNode(_toDisplayString($setup.lms_website.__('Quiz time will end after')) + " : ", 1 /* TEXT */),
                        _createElementVNode("b", null, "[ " + _toDisplayString($data.endCountdown) + "]", 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (!$options.checkQuizMaxAttempts && !$data.quiz.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString($setup.lms_website.__('You have reached the maximum number of attempts allowed for this quiz')), 1 /* TEXT */),
          _createCommentVNode("        <router-link :to=\"{name:'profile.my_quiz'}\"><b>{{ lms_website.__('Open Your Submissions') }}</b></router-link>")
        ]))
      : _createCommentVNode("v-if", true),
    (!$options.checkQuizStartTime($props.quizData?.start_time))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, [
            _createTextVNode(_toDisplayString($setup.lms_website.__('Quiz will start after')) + " : ", 1 /* TEXT */),
            _createElementVNode("b", null, "[ " + _toDisplayString($data.startCountdown) + "]", 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($options.checkQuizStartTime($props.quizData?.start_time))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          ($options.checkQuizEndTime($props.quizData.end_time))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($options.checkQuizMaxAttempts)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($data.quiz.is_submitted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            ($data.quiz.result?.pass)
                              ? (_openBlock(), _createBlock(_component_CheckMark, { key: 0 }))
                              : _createCommentVNode("v-if", true),
                            (!$data.quiz.result?.pass)
                              ? (_openBlock(), _createBlock(_component_FailMark, { key: 1 }))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("h3", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString($setup.lms_website.__('You got {0}%', [$data.quiz.result?.percentage])) + " - ", 1 /* TEXT */),
                              ($data.quiz.result?.pass)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString($setup.lms_website.__('Passed')), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              (!$data.quiz.result?.pass)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($setup.lms_website.__('Failed')), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("p", _hoisted_21, _toDisplayString($setup.lms_website.__('Your score is {0}/{1}.', [$data.quiz.result?.score, $data.quiz.result?.score_out_of])), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true),
                      (!$data.quiz.is_submitted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.quizQuestions, (question) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                _createElementVNode("fieldset", null, [
                                  _createElementVNode("div", {
                                    class: "question-title",
                                    innerHTML: question.question
                                  }, null, 8 /* PROPS */, _hoisted_23),
                                  _createElementVNode("div", _hoisted_24, [
                                    (question.type==='Choices')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("ul", _hoisted_25, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((question.answers), (answer) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, {
                                                key: answer.uid
                                              }, [
                                                (answer.answer)
                                                  ? (_openBlock(), _createElementBlock("li", {
                                                      key: 0,
                                                      class: "list-group-item d-flex align-items-center",
                                                      "data-uid": answer.uid
                                                    }, [
                                                      (!question.is_checked)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            (!question.multiple)
                                                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                  key: 0,
                                                                  class: "form-check-input form-check-input-lg mr-2",
                                                                  type: "radio",
                                                                  "onUpdate:modelValue": $event => (($data.quiz.answers[question.name]) = $event),
                                                                  id: `${question.name}-option_${answer.uid}`,
                                                                  value: answer.answer
                                                                }, null, 8 /* PROPS */, _hoisted_27)), [
                                                                  [_vModelRadio, $data.quiz.answers[question.name]]
                                                                ])
                                                              : _createCommentVNode("v-if", true),
                                                            (question.multiple)
                                                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                  key: 1,
                                                                  class: "form-check-input form-check-input-lg mr-2",
                                                                  type: "checkbox",
                                                                  "onUpdate:modelValue": $event => (($data.quiz.answers[question.name]) = $event),
                                                                  id: `${question.name}-option_${answer.uid}`,
                                                                  value: answer.answer
                                                                }, null, 8 /* PROPS */, _hoisted_28)), [
                                                                  [_vModelCheckbox, $data.quiz.answers[question.name]]
                                                                ])
                                                              : _createCommentVNode("v-if", true),
                                                            _createElementVNode("label", {
                                                              class: "form-check-label stretched-link",
                                                              for: `${question.name}-option_${answer.uid}`
                                                            }, _toDisplayString(answer.answer), 9 /* TEXT, PROPS */, _hoisted_29)
                                                          ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true),
                                                      (question.is_checked)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            (!answer.is_answered && !answer.is_correct)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, _hoisted_32))
                                                              : _createCommentVNode("v-if", true),
                                                            ((answer.is_answered && answer.is_correct) || answer.is_correct)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _hoisted_35))
                                                              : _createCommentVNode("v-if", true),
                                                            (answer.is_answered && !answer.is_correct)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, _hoisted_38))
                                                              : _createCommentVNode("v-if", true),
                                                            _createElementVNode("label", _hoisted_39, _toDisplayString(answer.answer), 1 /* TEXT */)
                                                          ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true)
                                                    ], 8 /* PROPS */, _hoisted_26))
                                                  : _createCommentVNode("v-if", true)
                                              ], 64 /* STABLE_FRAGMENT */))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]),
                                          (question.validate_error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                _hoisted_41,
                                                _createTextVNode(" " + _toDisplayString(question.validate_error), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true),
                                    (question.type==='User Input')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                          _withDirectives(_createElementVNode("textarea", {
                                            class: _normalizeClass(["form-control", {'is-invalid':(question.correct_error),'is-valid':(question.correct_success)}]),
                                            "onUpdate:modelValue": $event => (($data.quiz.answers[question.name]) = $event),
                                            style: {"height":"100px","resize":"none"},
                                            placeholder: "Your Answer"
                                          }, null, 10 /* CLASS, PROPS */, _hoisted_43), [
                                            [_vModelText, $data.quiz.answers[question.name]]
                                          ]),
                                          (question.correct_success)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                _hoisted_45,
                                                _createTextVNode(" " + _toDisplayString(question.correct_success), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (question.correct_error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                _hoisted_47,
                                                _createTextVNode(" " + _toDisplayString(question.correct_error), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (question.validate_error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                _hoisted_49,
                                                _createTextVNode(" " + _toDisplayString(question.validate_error), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("b", _hoisted_51, "Question " + _toDisplayString($data.quiz.pagination.currentPage) + " / " + _toDisplayString($data.quiz.data?.custom_number_of_questions), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_52, [
                                    ($data.quiz.data?.show_answers)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (!question.is_checked)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "btn btn-sm btn-primary",
                                                onClick: $event => ($options.quiz_check_answer(question)),
                                                disabled: !$data.quiz.answers[question.name] || !$data.quiz.answers[question.name]?.length
                                              }, [
                                                _hoisted_54,
                                                _createTextVNode(" Check")
                                              ], 8 /* PROPS */, _hoisted_53))
                                            : _createCommentVNode("v-if", true),
                                          (question.is_checked && ($data.quiz.pagination.currentPage < $data.quiz.data?.custom_number_of_questions))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                type: "button",
                                                class: "btn btn-sm btn-secondary",
                                                onClick: $event => ($options.next_question(question)),
                                                disabled: !$data.quiz.answers[question.name]
                                              }, [
                                                _createTextVNode("Next Question "),
                                                _hoisted_56
                                              ], 8 /* PROPS */, _hoisted_55))
                                            : _createCommentVNode("v-if", true),
                                          (question.is_checked && ($data.quiz.pagination.currentPage === $data.quiz.data?.custom_number_of_questions))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                type: "button",
                                                class: "btn btn-sm btn-primary",
                                                onClick: _cache[2] || (_cache[2] = $event => ($options.submit_answers())),
                                                disabled: !$data.quiz.answers[question.name]
                                              }, [
                                                _createTextVNode("Submit Answers "),
                                                _hoisted_58
                                              ], 8 /* PROPS */, _hoisted_57))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true),
                                    (!$data.quiz.data?.show_answers)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (($data.quiz.pagination.currentPage < $data.quiz.data?.custom_number_of_questions))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "btn btn-sm btn-secondary",
                                                onClick: $event => ($options.next_question(question)),
                                                disabled: !$data.quiz.answers[question.name] || !$data.quiz.answers[question.name]?.length
                                              }, [
                                                _createTextVNode("Next Question "),
                                                _hoisted_60
                                              ], 8 /* PROPS */, _hoisted_59))
                                            : _createCommentVNode("v-if", true),
                                          (($data.quiz.pagination.currentPage === $data.quiz.data?.custom_number_of_questions))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                type: "button",
                                                class: "btn btn-sm btn-primary",
                                                onClick: _cache[3] || (_cache[3] = $event => ($options.submit_answers())),
                                                disabled: !$data.quiz.answers[question.name]
                                              }, [
                                                _createTextVNode("Submit Answers "),
                                                _hoisted_62
                                              ], 8 /* PROPS */, _hoisted_61))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ])
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (!$options.checkQuizEndTime($props.quizData.end_time))
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _createElementVNode("p", _hoisted_64, [
                  _createTextVNode(_toDisplayString($setup.lms_website.__('See you tomorrow at')) + " : ", 1 /* TEXT */),
                  _createElementVNode("b", null, "[ " + _toDisplayString($setup.moment(`${$props.quizData.start_date} ${$props.quizData.start_time}`).format('hh:mm A')) + "]", 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}